export default __webpack_public_path__ + "static/how-nomba-qr-works-a4081ed293dd43c847166a7648b69bb8.mp4";